import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import reduceReducers from 'reduce-reducers';
import { reducer as formReducer } from 'redux-form';
import tableReducer from 'cl-table/redux/reducer';
/* viewDesigns */
import { accountPage, templates, user, wizard, upgrade, general, listingsPage, images, globalUpdate, ebayListing } from '../../../MyAccount/ViewDesigns/redux/modules/index';
import RealTimeDBReducer from 'shared/realTimeDB/RealTimeDBReducer';
import panel from 'crazyEditor/redux/modules/panel/panel';

export default reduceReducers(
  globalUpdate,
  combineReducers(
    {
      routing: routerReducer,
      templates,
      images,
      user,
      wizard,
      upgrade,
      accountPage,
      general,
      panel,
      settings: state => state || {},
      listingsPage,
      ebayListing,
      templateTagSet: state => state || {},
      form: formReducer,
      table: tableReducer,
    }),
  RealTimeDBReducer,
);

